import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading } from '../../components';

import { FaClock } from 'react-icons/fa';

import css from './SectionEnumMaybe.module.css';

const SectionEnumMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const groomingKeys = ['start_time_grooming', 'end_time_grooming'];

  const pickGroomingTimeFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;

    if (!groomingKeys.includes(key)) {
      return filteredConfigs;
    }

    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;

    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue !== 'undefined' ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue =>
        enumOptions?.find(o => enumValue === `${o.option}` || enumValue === o.key);

      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({
            key,
            value: optionConfig?.label || value,
            label: label || key.replace(/_/g, ' '),
          })
        : filteredConfigs;
    }

    return filteredConfigs;
  };

  const groomingTimeFields = listingFieldConfigs.reduce(pickGroomingTimeFields, []);

  const iconMap = {
    start_time_grooming: <FaClock />,
    end_time_grooming: <FaClock />,
  };

  return groomingTimeFields.length > 0 ? (
    <section className={css.sectionText} id="grooming-time">
      <ul className={css.container}>
        {groomingTimeFields.map(detail => (
          <li key={detail.key} className={css.item}>
            <span className={css.icon}>{iconMap[detail.key]}</span>
            <div className={css.row}>
              
              <Heading as="h5" className={css.sectionHeading}>{detail.label}</Heading>
               <div className={css.text}>{detail.value}</div>
            </div>
           
          </li>
        ))}
      </ul>
    </section>
  ) : null;
};

export default SectionEnumMaybe;
